import { useStore } from 'storesProvider/storeContext';
import { IProject } from '../types';

export const getProjectById = (id: number): IProject | null => {
  const { projectSearchStore } = useStore();
  return projectSearchStore.projectsData.data.find((project) => project.id === id) || null;
};
